import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import Modal from '@components/Modal/index';

function ModalWrapper({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      <Modal />
    </>
  );
}

export default withErrorBoundary(ModalWrapper, {
  FallbackComponent: ErrorBoundaryFallback,
});
